module.exports = __webpack_public_path__ + "img/61-image-2@2x.ca61c9cd.png";